import React from 'react';

type Props = {
  className?: string;
  children: React.ReactNode;
};

export default function ModalNotice({ className, children }: Props) {
  return (
    <div
      className={`modal-notice rounded-[10px] bg-apps-coreGray05 p-5 ${className ?? ''}`}
    >
      {children}
    </div>
  );
}
